import axios from "axios";

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/pickUpCar`;

const FetchDriverList = async resource => (
	await axios.post(`${API_PATH}/drivers`, resource)
);

const FetchDriverDetail = async resource => (
	await axios.post(`${API_PATH}/driver/detail`, resource)
);

const FetchRecord = async resource => (
	await axios.post(`${API_PATH}/record`, resource)
);

const FetchRecordDetail = async resource => (
	await axios.post(`${API_PATH}/record/detail`, resource)
);

export { FetchDriverList, FetchDriverDetail, FetchRecord, FetchRecordDetail };
